<script lang='ts'>
    export let xss = 0;
    export let xlss = 0;
    export let xhss = 0;
    export let xpss = 0;

    export let width = 10;

    export let noActivity = false;
    export let conflictDay = false;
    export let isRest = false
    
    // This would work for any array of numbers and string of colors the same size
    // function getArrayStopGradient(values: number[], colors: string[], angle: string){
    //     let total = values.reduce((prev, curr) =>{return prev+curr})
    //     let percents = values.map((val)=>{return val/total*100})
    //     let stops: number[] = []
    //     percents.forEach(
    //         (percent, i) => {
    //             if (i===0){
    //                 stops.push(percent)
    //             } else {
    //                 stops.push(percent + stops[i-1])
    //             }
    //         }
    //     )
    //     let linear_gradient = `linear-gradient(${angle},`
    //     colors.forEach(
    //         (color, i) => {
    //             if (i === 0){
    //                 linear_gradient += ` ${color} 0% ${stops[i]}%,`
    //             } else if (i+1 === colors.length){
    //                 linear_gradient += ` ${color} ${stops[i-1]}% 100%);`
    //             } else {
    //                 linear_gradient += ` ${color} ${stops[i-1]}% ${stops[i]}%,`
    //             }
    //         }
    //     )
    //     return linear_gradient
    // }
    // $: linear_gradient = getArrayStopGradient([xlss, xhss, xpss], ["var(--color-xlss)", "var(--color-xhss)", "var(--color-xpss)"], "0deg")


    let _class, _background;
    $: if (conflictDay) {
        _class = 'conflict'
        _background = null
    } else if (isRest) {
        _class = 'rest'
        _background = null
    } else if (noActivity || !(xss > 0)) {
        _class = 'none'
        _background = null
    } else {
        _class = 'gradient'

        // Simplified gradient for just the 3 xss values
        const xss = xlss+xhss+xpss;
        const s0 = Math.round(xlss/xss*100.0)
        const s1 = Math.round((xlss + xhss)/xss*100.0)
        _background = `linear-gradient(0deg, var(--color-xlss) 0% ${s0}%, var(--color-xhss) ${s0}% ${s1}%, var(--color-xpss) ${s1}% 100%)`;
    }
</script>

<div class={_class} style:background={_background} style:width="{width}px"></div>

<style>
    .none {
        background-color: grey;
    }
    .rest {
        background-color: none;
    }
    .conflict {
        background-color: #ff00ff;
    }
</style>